import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoContratoService {

private apiUrl =  `${environment.apiUrl}/api/tipocontrato`; 
  //private apiUrl = 'http://localhost:3000/api/tipocontrato';

  constructor(private http: HttpClient) {}

  getTiposContrato(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl, {
      withCredentials: true
    }).pipe(
      catchError(error => {
        console.error('Error al obtener los tipos de contrato:', error);
        return throwError(() => new Error('Error al obtener los tipos de contrato'));
      })
    );
  }
}
